import React from "react";
import type { FC } from "react";

import cn from "classnames";

import type { IndicatorCoreExtendedProps } from "./types";

import classes from "./IndicatorCore.styl";

const INDICATOR_CORE_DISPLAY_NAME = "IndicatorCore";

export const IndicatorCore: FC<IndicatorCoreExtendedProps> = ({
    "data-tsid": tsid = INDICATOR_CORE_DISPLAY_NAME,
    cutout = true,
    view = "primary",
    children,
    customVarsStyles,
    customColorsStyles,
    className,
}) => {
    const wrapperClasses = cn(
        classes["wrapper"],
        classes[`__style-${view}`],
        view === "custom" && customColorsStyles,
        {
            [classes["__cutout"]]: cutout,
        },
        customVarsStyles,
        className,
    );

    return (
        <div
            className={wrapperClasses}
            data-tsid={tsid}
            data-uikit={INDICATOR_CORE_DISPLAY_NAME}
            // Компонент озвучивается только в составе других компонентов
            aria-hidden="true"
        >
            {children}
        </div>
    );
};

IndicatorCore.displayName = INDICATOR_CORE_DISPLAY_NAME;
